import React, { useEffect } from "react";
import { toCloudFront } from "./CourseCoverWorkspace";

const LessonForm = ({ lesson, setLesson, topicHeaderDetails, topicNumber }) => {
  useEffect(() => {
    if (topicHeaderDetails) {
      setLesson((prev) => ({
        ...prev,
        topicHeaderNumber: topicHeaderDetails.topicHeaderNumber || "",
        topicHeader: topicHeaderDetails.topicHeader || "",
      }));
    }
  }, [topicHeaderDetails, setLesson]);

  useEffect(() => {
    if (topicNumber) {
      setLesson((prev) => ({
        ...prev,
        topicNumber,
      }));
    }
  }, [topicNumber, setLesson]);

  return (
    <div>
      <div className="form-row">
        <div className="form-text">Topic</div>
        <input
          type="text"
          name="topicHeaderNumber"
          value={lesson.topicHeaderNumber || ""}
          readOnly
          tabIndex={-1}
          className="lesson-form-input number-input"
        />
        <input
          type="text"
          name="topicHeader"
          value={lesson.topicHeader || ""}
          readOnly
          tabIndex={-1}
          className={`lesson-form-input ${!lesson.topicHeader ? "empty" : ""}`}
        />
      </div>
      <div className="form-row">
        <span className="form-text">Chapter</span>
        <input
          type="text"
          name="topicNumber"
          value={lesson.topicNumber || ""}
          readOnly
          tabIndex={-1}
          className="lesson-form-input number-input"
        />
        <input
          type="text"
          name="topicTitle"
          value={lesson.topicTitle || ""}
          readOnly
          tabIndex={-1}
          className={`lesson-form-input ${!lesson.topicTitle ? "empty" : ""}`}
        />
      </div>
      <div className="form-row">
        <span className="form-text">Lesson</span>
        <input
          type="text"
          name="sectionNumber"
          value={lesson.sectionNumber || ""}
          readOnly
          tabIndex={-1}
          className="lesson-form-input number-input"
        />
        <input
          type="text"
          name="sectionTitle"
          value={lesson.sectionTitle || ""}
          readOnly
          tabIndex={-1}
          className={`lesson-form-input ${!lesson.sectionTitle ? "empty" : ""}`}
        />
      </div>
      <div className="form-row form-row-image">
        <div className="form-image-copy">
          <div className="form-text form-text-wide">Lesson image</div>
          <div className="form-image-hint">
            Appears on the lesson menu side navigation bar
          </div>
        </div>
        {lesson.sectionImage ? (
          <img
            className="lesson-form-image"
            src={toCloudFront(lesson.sectionImage)}
            alt={lesson.sectionTitle || "Lesson"}
          />
        ) : (
          <div className="lesson-form-image-empty">No image</div>
        )}
      </div>
    </div>
  );
};

export default LessonForm;
